(function () {
    function initReveal() {
      const reveals = document.querySelectorAll('.reveal');
      const blocks = document.querySelectorAll('.block');
  
      if (!reveals.length) return;
  
      function revealOnScroll() {
        reveals.forEach(el => {
          const r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.82) {
            el.classList.add('visible');
          }
        });
      }
  
      function syncLeftBlocks() {
        blocks.forEach(block => {
          const r = block.getBoundingClientRect();
          const activeBandTop = window.innerHeight * 0.62;
          const activeBandBottom = window.innerHeight * 0.28;
  
          if (r.top < activeBandTop && r.bottom > activeBandBottom) {
            blocks.forEach(b => b.classList.remove('active'));
            block.classList.add('active');
          }
        });
      }
  
      function onScroll() {
        revealOnScroll();
        syncLeftBlocks();
      }
  
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  
    document.addEventListener('DOMContentLoaded', initReveal);
  
    // Shopify Theme Editor support
    document.addEventListener('shopify:section:load', initReveal);
  })();
  